function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBrowsingHistoryRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8v7h8v-2h-6V8h-2zM2 20h3v-2H2v2zM2 25h3v-2H2v2zM7 20h7v-2H7v2zM7 25h7v-2H7v2zM2 30h3v-2H2v2zM7 30h7v-2H7v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2C12.925 2 8 6.925 8 13c0 1.042.154 2.045.425 3h2.1A8.936 8.936 0 0110 13c0-4.963 4.037-9 9-9s9 4.037 9 9c0 4.962-4.037 9-9 9a8.936 8.936 0 01-3-.525v2.1c.955.271 1.959.425 3 .425 6.075 0 11-4.925 11-11S25.075 2 19 2z",
    fill: props.color
  }));
}

export default SvgIconBrowsingHistoryRexOutline;